import React from 'react';
import { Github, Linkedin, Mail, ArrowUp } from 'lucide-react';
import { scrollToSection } from '../../utils';
import './Footer.css';

const quickLinks = ['Home', 'About', 'Services', 'Projects', 'Skills', 'Contact'];

const Footer = ({ setActiveSection }) => {
  const handleNav = (item) => scrollToSection(item.toLowerCase(), setActiveSection);

  return (
    <footer className="footer">
      <div className="footer-gradient-divider" />
      <div className="footer-container">

        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo gradient-text">EW</div>
            <p className="footer-tagline">
              Building scalable backends and elegant solutions — one line of code at a time.
            </p>
            <div className="footer-social">
              <a href="https://github.com/ebraheem54" target="_blank" rel="noopener noreferrer"
                 className="footer-social-link glass glass-hover">
                <Github size={18} />
              </a>
              <a href="https://www.linkedin.com/in/ebraheem-wannous" target="_blank" rel="noopener noreferrer"
                 className="footer-social-link glass glass-hover">
                <Linkedin size={18} />
              </a>
              <a href="mailto:ebraheem.sy370@gmail.com"
                 className="footer-social-link glass glass-hover">
                <Mail size={18} />
              </a>
            </div>
          </div>

          <div className="footer-nav-col">
            <p className="footer-nav-heading">Quick Links</p>
            <ul className="footer-nav-list">
              {quickLinks.map((link) => (
                <li key={link}>
                  <button onClick={() => handleNav(link)} className="footer-nav-link">
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-contact-col">
            <p className="footer-nav-heading">Get In Touch</p>
            <div className="footer-contact-info">
              <a href="mailto:ebraheem.sy370@gmail.com" className="footer-contact-item">
                <Mail size={15} />
                ebraheem.sy370@gmail.com
              </a>
              <a href="https://www.linkedin.com/in/ebraheem-wannous" target="_blank" rel="noopener noreferrer"
                 className="footer-contact-item">
                <Linkedin size={15} />
                LinkedIn Profile
              </a>
              <a href="https://github.com/ebraheem54" target="_blank" rel="noopener noreferrer"
                 className="footer-contact-item">
                <Github size={15} />
                GitHub Profile
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Ebraheem Wannous. All rights reserved.
          </p>
          <button onClick={() => handleNav('home')} className="footer-back-top">
            <ArrowUp size={16} />
            Back to top
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
